import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ServerRootService } from "../utils/routing/serverroot.service";

export enum AuditType {
    AlertReceived = 38,
    WarningReceived = 40,
}

@Injectable({ providedIn: 'root' })
export class AuditService extends ServerRootService {
    constructor(private readonly http: HttpClient) {
        super();
    }

    storeUserAudit(auditType: AuditType, auditText: string) {
        const body = {
            auditType,
            auditText,
        };

        return this.http.post<unknown>(`${this.getServerRoot()}/Audit/StoreUserAudit`, body, this.buildOptions());
    }
}
